import { Dropdown, DropdownChangeParams } from 'primereact/dropdown';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import { MultiSelect, MultiSelectChangeParams } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { useCookies } from 'react-cookie';

const Filters = ({
	countriesOptions,
	divisionsOptions,
	quartersOptions,
	yearsOptions,
	statusesOptions,
	divisionFilter,
	countryFilter,
	quarterFilter,
	yearFilter,
	statusFilter,
	setDivisionsFilter,
	setCountryFilter,
	setQuarterFilter,
	setYearFilter,
	setStatusFilter,
	clearAllFilters
}: IFiltersProps): JSX.Element => {
	const [cookies, setCookie] = useCookies([
		'periodStatusDivisions',
		'periodStatusCountries',
		'periodStatusQuarters',
		'periodStatusYears',
		'periodStatusStatuses'
	]);

	return (
		<div className={styles.container}>
			<MultiSelect
				style={{ width: '14%' }}
				className={styles.filter}
				value={divisionFilter}
				options={divisionsOptions}
				placeholder='Select a Division'
				onChange={(e: MultiSelectChangeParams) => {
					setDivisionsFilter(e.value);
					setCookie('periodStatusDivisions', e.target.value);
				}}
			/>
			<MultiSelect
				style={{ width: '14%' }}
				className={styles.filter}
				value={countryFilter}
				options={countriesOptions}
				placeholder='Select a Country'
				onChange={(e: MultiSelectChangeParams) => {
					setCountryFilter(e.value);
					setCookie('periodStatusCountries', e.target.value);
				}}
			/>
			<MultiSelect
				style={{ width: '14%' }}
				className={styles.filter}
				placeholder='Quarter'
				value={quarterFilter}
				options={quartersOptions}
				onChange={(e: MultiSelectChangeParams) => {
					setQuarterFilter(e.value);
					setCookie('periodStatusQuarters', e.target.value);
				}}
			/>
			<MultiSelect
				style={{ width: '14%' }}
				className={styles.filter}
				placeholder='Year'
				value={yearFilter}
				options={yearsOptions}
				onChange={(e: MultiSelectChangeParams) => {
					setYearFilter(e.value);
					setCookie('periodStatusYears', e.target.value);
				}}
			/>
			<MultiSelect
				style={{ width: '14%' }}
				className={styles.filter}
				placeholder='Select a Status'
				value={statusFilter}
				options={statusesOptions}
				onChange={(e: MultiSelectChangeParams) => {
					setStatusFilter(e.value);
					setCookie('periodStatusStatuses', e.target.value);
				}}
			/>
			<Button className={styles.filterClearBtn} onClick={clearAllFilters}>
				<img src='/assets/icon-trash.svg' alt='trash icon' />
				Clear all filters
			</Button>
		</div>
	);
};

export default Filters;
